import { Component } from 'vue-facing-decorator';
import VueCqrs from '@cqrs/vue-component-cqrs';
import * as q from '@Alternatives/Assignments/Domain/queries';

@Component
export default class AssignmentsQueries extends VueCqrs
{
	runManageAssignmentsPageQueryV1(workspaceId: number, tchProjectId: number, viewDefId: string | null)
	{
		const query = q.buildManageAssignmentsPageQueryV1(workspaceId, tchProjectId, viewDefId);
		this.$query(query);
	}
}